const VideoModal = ({ url, closeModal }) => {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{
          display: "block",
          background: "rgba(0, 0, 0, 0.5)", // Add overlay effect
        }}
        aria-labelledby="exampleModalLabel"
        aria-hidden="false"
      >
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="modal-content p-3" style={{ width: "1000px" }}>
            <div className="modal-body position-relative">
              {/* Close Button */}
              <button
                type="button"
                className="btn-close-iframe position-absolute top-0 end-0 m-2"
                onClick={closeModal}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>

              {/* Video Player */}
              {url ? (
                <video
                  src={url}
                  controls
                  autoPlay
                  style={{
                    width: "100%",
                    height: "500px",
                    borderRadius: "10px",
                  }}
                />
              ) : (
                <p className="text-center">No video available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoModal;
